/**
 * [BD feat] Newsletter — scroll-linked horizontal motion for split headlines
 */
(function () {
  let scrollRaf = null;

  function headlineScrollProgress(root) {
    const rect = root.getBoundingClientRect();
    const vh = window.innerHeight;
    const denom = vh + rect.height;
    if (denom <= 0) return 0;
    return Math.min(1, Math.max(0, (vh - rect.top) / denom));
  }

  function updateNewsletterHeadlines() {
    scrollRaf = null;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-newsletter-headline-scroll]').forEach((root) => {
      root.style.setProperty('--nl-headline-scroll', headlineScrollProgress(root).toFixed(4));
    });
  }

  function scheduleUpdate() {
    if (scrollRaf != null) return;
    scrollRaf = window.requestAnimationFrame(updateNewsletterHeadlines);
  }

  if (!window.__bdNewsletterHeadlineScrollBound) {
    window.__bdNewsletterHeadlineScrollBound = true;
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('load', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate, { passive: true });
    document.addEventListener('touchmove', scheduleUpdate, { passive: true });
    document.addEventListener('shopify:section:load', scheduleUpdate);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleUpdate, { passive: true });
      window.visualViewport.addEventListener('scroll', scheduleUpdate, { passive: true });
    }
  }

  updateNewsletterHeadlines();
})();
